import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';

var firebaseConfig = {
    apiKey: "AIzaSyA3eaJyPsSgP4w44xec072whAo3ylvlHkY",
    authDomain: "moval-4c0b4.firebaseapp.com",
    projectId: "moval-4c0b4",
    storageBucket: "moval-4c0b4.appspot.com",
    messagingSenderId: "852374290766",
    appId: "1:852374290766:web:0996678ff44c53119fde1f"
  };

// wichtig: nur einmal initialisieren
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export default firebase;